module.exports = __webpack_public_path__ + "img/question_03_icon.7b46c664.png";